import * as Yup from 'yup';
import { INVALID_FIELDS, YupString } from './general';

export const CreateOrganizationSchema = Yup.object().shape({
  orgId: YupString.nullable(),
  name: YupString.nullable().required(INVALID_FIELDS.REQUIRED),
  subdomain: YupString.nullable()
    .required(INVALID_FIELDS.REQUIRED)
    .matches(/^[a-zA-Z0-9-_]+$/, INVALID_FIELDS.SUB_DOMAIN),
  orgType: YupString,
  superAdmin: Yup.object().shape({
    firstName: YupString.nullable().required(INVALID_FIELDS.REQUIRED),
    lastName: YupString.nullable().required(INVALID_FIELDS.REQUIRED),
    email: YupString.email(INVALID_FIELDS.EMAIL)
      .nullable()
      .required(INVALID_FIELDS.REQUIRED),
  }),
});

export const UpdateOrganizationSchema = Yup.object().shape({
  orgId: YupString.nullable(),
  name: YupString.nullable().required(INVALID_FIELDS.REQUIRED),
  subdomain: YupString.nullable()
    .required(INVALID_FIELDS.REQUIRED)
    .matches(/^[a-zA-Z0-9-_]+$/, INVALID_FIELDS.SUB_DOMAIN),
  orgType: YupString,
});
